import { createFileRoute } from '@tanstack/react-router';

import { getCandidateCommentaryOptions } from 'client/@tanstack/react-query.gen';

export const Route = createFileRoute(
  '/_private/_route/_internal/people/$identityId/_candidate/about/',
)({
  loader: async ({ context }) => {
    const { queryClient } = context;
    const pCommentary = queryClient.ensureQueryData(
      getCandidateCommentaryOptions({
        path: {
          candidate_uuid: context.candidate.uuid,
        },
      }),
    );
    await Promise.all([pCommentary]);
  },
});
